<template>
    <DataTable :value="data"
               class="p-datatable-responsive"
               rowGroupMode="rowspan"
               :groupRowsBy="groupRowsBy"
               :autoLayout="true"
               dataKey="type" :rowClass="transparentIfNotFullscreen">
        <template #header>
            {{ header }}
        </template>
        <Column field="type" :header-class="transparentIfNotFullscreen()" body-style="font-weight: bold"></Column>
        <Column body-style="text-align: right" :header-class="transparentIfNotFullscreen()"
                :header="targetYear">
            <template #body="slotProps">
                <span v-if="!(typeof data[data.length-1][targetYear] === 'string')">
                {{
                    Number(slotProps.data[targetYear] || 0).toLocaleString('da-DK', {maximumFractionDigits: 0})
                }}
                </span>
                <span v-if="typeof data[data.length-1][targetYear] === 'string' && slotProps.index<data.length-1">
                {{
                    Number(slotProps.data[targetYear] || 0).toLocaleString('da-DK', {maximumFractionDigits: 2})
                }}
                </span>
                <span v-if="typeof data[data.length-1][targetYear] === 'string' && slotProps.index==data.length-1">
                    <img :src="slotProps.data[targetYear]" :alt="slotProps.data[targetYear]" style="height:75px"/>
                </span>
            </template>
        </Column>
        <Column body-style="text-align: right" :header-class="transparentIfNotFullscreen()" :header="baseYear">
            <template #body="slotProps">
                <span v-if="!(typeof data[data.length-1][targetYear] === 'string')">
                {{
                    Number(slotProps.data[baseYear] || 0).toLocaleString('da-DK', {maximumFractionDigits: 0})
                }}
                </span>
                <span v-if="typeof data[data.length-1][targetYear] === 'string' && slotProps.index<data.length-1">
                {{
                    Number(slotProps.data[baseYear] || 0).toLocaleString('da-DK', {maximumFractionDigits: 2})
                }}
                </span>
                <span v-if="typeof data[data.length-1][targetYear] === 'string' && slotProps.index==data.length-1">
                    <img :src="slotProps.data[baseYear]" :alt="slotProps.data[targetYear]" style="height:75px"/>
                </span>
            </template>
        </Column>
        <Column field="grouped" :body-style="{fontSize: Math.max(1, 1.8 - (data && data.length || 0) / 20) + 'em', textAlign: 'center', fontWeight: 'bolder'}"
                :header-class="transparentIfNotFullscreen()">
            <template #body="slotProps">
                <span :style="slotProps.data.grouped < 0 ? {color: 'rgb(43, 141, 58)'} : {color: 'red'}">
                    {{
                        slotProps.data.grouped && Number(slotProps.data.grouped).toLocaleString(undefined, {
                            style: 'percent',
                            maximumFractionDigits: 0
                        })
                    }}
                </span>
            </template>
        </Column>
    </DataTable>
</template>

<script>
export default {
    props: {
        data: Array,
        baseYear: null,
        targetYear: null,
        groupRowsBy: {
            type: String,
            default: null
        },
        fullscreen: {
            type: Boolean,
            default: false
        },
        header: String
    },
    methods: {
        transparentIfNotFullscreen() {
            return this.fullscreen ? 'no-background' : null;
        }
    }
}
</script>